/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvYWRtaW4vaGNhLWFkbWluL21lbWJlcnMvbWVtYmVycy1tYW5hZ2VtZW50L21lbWJlcnMvbWVtYmVycy5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2FkbWluL2hjYS1hZG1pbi9tZW1iZXJzL21lbWJlcnMtbWFuYWdlbWVudC9tZW1iZXJzL21lbWJlcnMuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/admin/hca-admin/members/members-management/members/members.component.scss.shim.ngstyle.ts